import { render, staticRenderFns } from "./ProcessAngebotHeader.vue?vue&type=template&id=9516078a&"
import script from "./ProcessAngebotHeader.vue?vue&type=script&lang=js&"
export * from "./ProcessAngebotHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports